<template>
	<b-modal id="subject_form_modal" ref="bvModal" :no-close-on-backdrop="true">
		<template v-slot:modal-header="{ close }">
			<div class="modal-header-buttons-container">
				<div class="placeholder"></div>
				<h2>{{ modalTitle }}</h2>
				<div class="placeholder"></div>
			</div>
		</template>
		<div class="modal-body-section">
			<perfect-scrollbar class="mr-n5 scroll" style="max-height: 85vh; position: relative; padding: 0px 5px">
				<div class="modal-inputs-holder">
					<!-- client select &  prosecutor&defendant-->
					<div class="form-groups-container">
						<div class="bb-form-group client-select">
							<label>{{ $t('subjectFormModal.clientInput.label') }}</label>
							<BBSelect @input_typed_event="asyncFindClients" v-model="form.fields.subjectableId" :options="this.form.helpers.clientOptions" :search="true" :placeholder="$t('subjectFormModal.clientInput.placeholder')" :searchPlaceholder="$t('subjectFormModal.clientInput.searchPlaceholder')" :noOptionsText="$t('subjectFormModal.clientInput.noResultsText')" @optionSelected="handleSelected">
								<template v-slot:optionItem="{ option }">
									<div class="badge-option-container">
										<div class="badge-option">
											<div class="bb-badge">{{ option.id }}</div>
											<div class="badge-option-text">
												<span>{{ option.text }}</span>
												<small>{{ $t('subjectFormModal.clientInput.' + option.type) }}</small>
											</div>
										</div>
									</div>
								</template>
								<template v-slot:optionsFooter>
									<div @click="showLawClientFormModal()">
										<i class="fas fa-plus"></i>
										<span>{{ $t("subjectFormModal.clientInput.createClient") }}</span>
									</div>
								</template>
							</BBSelect>
						</div>
						<div class="bb-form-group">
							<!-- <label>{{ $t("subjectFormModal.subjectNumber.label") }}</label> -->
							Prosecutor & defendant
							<input class="bb-input" type="number" />
							<div class="bb-invalid-feedback" v-show="form.errors.subjectNumber">
								{{ $t('subjectFormModal.validation.error') }}
							</div>
						</div>
					</div>
					<!-- subject type & dispute value -->
					<div class="form-groups-container">
						<div class="bb-form-group">
							<label>{{ $t('subjectFormModal.subjectType.label') }}</label>
							<BBSelect class="subject-type-select" v-model="form.fields.type" :search="true" :options="subjectTypeOptions"  :placeholder="$t('subjectFormModal.subjectTypeInput.placeholder')" :searchPlaceholder="$t('subjectFormModal.subjectTypeInput.searchPlaceholder')" :noOptionsText="$t('subjectFormModal.subjectTypeInput.noResultsText')">
								<template v-slot:optionItem="{ option }">
									<div class="badge-option-container">
										<div class="badge-option">
											<!-- <div class="bb-badge">{{ option.id }}</div> -->
											<div class="badge-option-text">
												<span>{{ option.text }}</span>
												<small>{{ option.type }}</small>
											</div>
										</div>
									</div>
								</template>
							</BBSelect>
							<div class="bb-invalid-feedback" v-show="form.errors.type">
								{{ $t('subjectFormModal.validation.error') }}
							</div>
						</div>
						<div class="bb-form-group">
							<label>{{ $t('subjectFormModal.disputeValue.label') }}</label>
							<input class="bb-input" type="number" v-model="form.fields.disputeValue" />
							<div class="bb-invalid-feedback" v-show="form.errors.disputeValue">
								{{ $t('subjectFormModal.validation.error') }}
							</div>
						</div>
					</div>
					<!-- Court case number & Internal case number -->
					<div class="form-groups-container">
						<div class="bb-form-group">
							<label>{{ $t('subjectFormModal.courtCaseNumber.label') }}</label>
							<input class="bb-input" type="text" v-model="form.fields.courtCaseNumber" />
							<div class="bb-invalid-feedback" v-show="form.errors.courtCaseNumber">
								{{ $t('subjectFormModal.validation.error') }}
							</div>
						</div>
						<div class="bb-form-group">
							<label>{{ $t('subjectFormModal.internalCaseNumber.label') }}</label>
							<input class="bb-input" type="text" v-model="form.fields.internalSubjectNumber" />
							<div class="bb-invalid-feedback" v-show="form.errors.internalSubjectNumber">
								{{ $t('subjectFormModal.validation.error') }}
							</div>
						</div>
					</div>
					<!-- Court & Acting judge -->
					<div class="form-groups-container">
						<div class="bb-form-group">
							<label>{{ $t('subjectFormModal.courtInput.label') }}</label>
							<div class="birthday-inputs">
								<BBSelect v-model="form.fields.courtName" :options="courtOptions" :search="true" :searchPlaceholder="$t('subjectFormModal.courtInput.searchPlaceholder')" :placeholder="$t('subjectFormModal.courtInput.placeholder')" :noOptionsText="$t('subjectFormModal.courtInput.noResultsText')"></BBSelect>
								<div class="bb-invalid-feedback" v-show="form.errors.courtName">
									{{ $t('subjectFormModal.validation.error') }}
								</div>
							</div>
						</div>
						<div class="bb-form-group">
							<label>{{ $t('subjectFormModal.actingJudge.label') }}</label>
							<div class="birthday-inputs">
								<input class="bb-input" type="text" v-model="form.fields.actingJudge" />
								<div class="bb-invalid-feedback" v-show="form.errors.actingJudge">
									{{ $t('subjectFormModal.validation.error') }}
								</div>
							</div>
						</div>
					</div>
					<!-- Note -->
					<div class="bb-form-group note">
						<label>{{ $t('subjectFormModal.note.label') }}</label>
						<div class="birthday-inputs">
							<textarea class="bb-input" type="text" v-model="form.fields.note" id="" cols="30" rows="10"></textarea>
							<div class="bb-invalid-feedback" v-show="form.errors.note">
								{{ $t('subjectFormModal.validation.error') }}
							</div>
						</div>
					</div>
				</div>
			</perfect-scrollbar>
		</div>
		<template v-slot:modal-footer="{ close }">
			<div class="footer-right">
				<button id="subject_form_modal_close_btn" class="bb-btn btn-outline" @click="close(); clearOptions(); clearSelectedType()">
					{{ $t('subjectFormModal.closeBtn') }}
				</button>
				<button class="bb-btn btn-success" @click="submit()">
					{{ $t('subjectFormModal.saveBtn') }}
				</button>
			</div>
		</template>
		<LawClientModal ref="lawClientModal" />
	</b-modal>
</template>

<script>
import { SET_ALERT_MESSAGES } from '@/core/services/store/alert.module.js';
import { GET_SUBJECTS } from '@/core/services/store/subjects.module';
import { OPEN_ELEMENT } from '@/core/services/store/offcanvas.module.js';
// import { EventBus } from '@/core/services/event-bus.js';
import httpService from '@/core/services/http.service.js';
import i18nService from '@/core/services/i18n.service.js';
import subjectForm from '@/core/services/forms/subjectForm.js';
import formMixin from '@/core/mixins/formMixin.js';
import BBSelect from '@/view/content/BBForm/BBSelect.vue';
import LawClientModal from '@/view/layout/extras/modal/LawClientModal.vue';
import lawClientModalMixin from '@/core/mixins/lawClientModalMixin.js';
// import BBSwitch from '@/view/content/BBForm/BBSwitch.vue';
import moment from 'moment';
import _ from 'lodash';

export default {
	name: 'SubjectFormModal',
	mixins: [formMixin, lawClientModalMixin],
	components: {
		BBSelect,
		LawClientModal,
		// BBSwitch,
	},
	data() {
		return {
			clientOptions: [],
			selectedClientType: null,
		};
	},
	beforeMount() {
		// Get form object from subjectForm service
		this.form = JSON.parse(JSON.stringify(subjectForm));
		// Set moment locale
		moment.locale(i18nService.getActiveLanguage());
	},
	methods: {
		/**
		 * Method for api call for client select options
		 * @return {Array}
		 */
		asyncFindClients(query) {
			if (query != '') {
				httpService
					.get(`/api/b2b/physical-entities/options?search=${query}`)
					.then((physicalEntities) => {
						this.form.helpers.clientOptions = physicalEntities.data;
						httpService
							.get(`/api/b2b/legal-entities/options?search=${query}`)
							.then((legalEntities) => {
								this.form.helpers.clientOptions = _.concat(this.form.helpers.clientOptions, legalEntities.data);
							})
							.catch((error) => {
								this.$store.dispatch(SET_ALERT_MESSAGES, {
									successMessages: null,
									errorMessages: [error.response.data.message],
								});
							});
					})
					.catch((error) => {
						this.$store.dispatch(SET_ALERT_MESSAGES, {
							successMessages: null,
							errorMessages: [error.response.data.message],
						});
					});
				
			} else {
				this.clearOptions();
			}
		},

		/**
		 * Set client type data property
		 */
		handleSelected(client) {
			this.selectedClientType = client.type;
		},

		/**
		 * Clear selected client
		 * @return {void}
		 */
		clearOptions() {
			this.form.helpers.clientOptions = [];
		},

		clearSelectedType() {
			this.selectedClientType = null;
		},

		/**
		 * Show the modal
		 * @return {void}
		 */
		show() {
			this.$refs.bvModal.show();
		},

		/**
		 * Close the modal
		 * @return {void}
		 */
		closeModal() {
			document.querySelector('#subject_form_modal_close_btn').click();
		},

		/**
		 * Open offcanvas element by given offcanvas element id
		 * @param {String} elementId
		 * @return {void}
		 */
		openOffcanvas(elementId) {
			document.querySelector('#' + elementId + '_toggle').click();
			this.$store.dispatch(OPEN_ELEMENT, elementId);
		},

		/**
		 * Update form fields from form helpers
		 * @return {void}
		 */
		updateFormFields() {
			this.form.fields.subjectableType = this?.selectedClientType ?? this.form.fields.subjectableType;
		},

		/**
		 * Submit the form
		 * @return {void}
		 */
		submit() {
			this.updateFormFields();
			this.submitForm()
				.then((response) => {
					this.$store.dispatch(SET_ALERT_MESSAGES, {
						successMessages: [response.data.message],
						errorMessages: null,
					});
					this.closeModal();
					if (this.form.mode === 'edit') {
						this.closeModal();
						this.$store.dispatch(GET_SUBJECTS, { pageNumber: 1});
					} else {
						this.$store.dispatch(GET_SUBJECTS, { pageNumber: 1});
					}
				})
				.catch((error) => {
					this.$store.dispatch(SET_ALERT_MESSAGES, {
						successMessages: null,
						errorMessages: [error.response.data.message],
					});
				});
		},

		/**
		 * Open MobileClientSelect element and add form key attribute to element
		 * @return {void}
		 */
		selectClient() {
			document.querySelector('#mobile_client_select').setAttribute('form-key', 'subjectFormModal');
			this.openOffcanvas('mobile_client_select');
		},
	},
	computed: {
		/**
		 * Return array of courts options
		 * @return {Array}
		 */
		courtOptions() {
			let courtOptions = [];
			let courts = require('@/assets/data/courts.json');
			for (let i = 0; i < courts.length; i++) {
				let option = {
					text: courts[i],
					value: courts[i],
				};
				courtOptions.push(option);
			}
			return courtOptions;
		},

		subjectTypeOptions() {
			let subjectTypeOptions = [];
			let types = require('@/assets/data/subjectTypes.json');

			if (this.selectedClientType == 'physicalEntity' || (this.form.fields.client?.entity_type == 'physicalEntity' && this.form.mode == 'edit')) {
				let physicalEntityTypes = types.physicalEntitiesTypes;
				for (let i = 0; i < physicalEntityTypes[0].length; i++) {
					let option = {
						text: physicalEntityTypes[0][i],
						value: physicalEntityTypes[0][i],
						type: this.$t('subjectFormModal.clientType.physicalEntities.firstLevelCourt'),
					};
					subjectTypeOptions.push(option);
				}
				for (let i = 0; i < physicalEntityTypes[1].length; i++) {
					let option = {
						text: physicalEntityTypes[1][i],
						value: physicalEntityTypes[1][i],
						type: this.$t('subjectFormModal.clientType.physicalEntities.higherLevelCourt'),
					};
					subjectTypeOptions.push(option);
				}
			}
			if (this.selectedClientType == 'legalEntity' || (this.form.fields.client?.entity_type == 'legalEntity' && this.form.mode == 'edit')) {
				let legalEntitiesOptions = types.legalEntitiesTypes;
				for (let i = 0; i < legalEntitiesOptions[0].length; i++) {
					let option = {
						text: legalEntitiesOptions[0][i],
						value: legalEntitiesOptions[0][i],
						type: this.$t('subjectFormModal.clientType.legalEntities.firstLevelCourt'),
					};
					subjectTypeOptions.push(option);
				}
				for (let i = 0; i < legalEntitiesOptions[1].length; i++) {
					let option = {
						text: legalEntitiesOptions[1][i],
						value: legalEntitiesOptions[1][i],
						type: this.$t('subjectFormModal.clientType.legalEntities.higherLevelCourt'),
					};
					subjectTypeOptions.push(option);
				}
			}
			return subjectTypeOptions;
		},

		/**
		 * Return modal title
		 * @return {String}
		 */
		modalTitle() {
			return this.form.mode === 'edit' ? this.$t('subjectFormModal.editTitle') : this.$t('subjectFormModal.createTitle');
		},
	},
};
</script>
<style lang="scss">
@import '@/assets/sass/bb-styles/modals/subject-form-modal.scss';
</style>
